import { Redirect } from '@reach/router';
import React from 'react';

import { IRedirectProps } from './types';

const RedirectWrapper: React.FC<IRedirectProps> = (props) => (
  <Redirect {...props} to={props.to} />
);

export default RedirectWrapper;
